module.exports = __webpack_public_path__ + "static/media/7.dacd91af.jpg";